import type { SidebarNavItem } from '@m3-tech/boss-ui'

/**
 * First navigable leaf path within a nav item, drilling through a leading group
 * (mirrors the sidebar's own "click a parent → go to its first child" behavior).
 * Returns `undefined` when the item exposes no navigable leaf.
 */
export function firstLeafPath(item: SidebarNavItem): string | undefined {
    if (item.path) return item.path
    for (const child of item.children ?? []) {
        if ('children' in child) {
            const leaf = child.children.find((l) => l.path)
            if (leaf?.path) return leaf.path
        } else if (child.path) {
            return child.path
        }
    }
    return undefined
}
